import script from "./SelectBranches.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBranches.vue?vue&type=script&setup=true&lang=js"

import "./SelectBranches.vue?vue&type=style&index=0&id=be083e72&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be083e72"]])

export default __exports__